import { createIntentType } from './intent';
export function createArrayIntentType(label, create) {
    return createIntentType(label, {
        add (intent, state = []) {
            state.push(intent);
            return state;
        },
        create,
        merge (target, source) {
            if (target) {
                target.push(...source);
                return target;
            } else {
                return source.slice();
            }
        }
    });
}

//# sourceMappingURL=createArrayIntentType.js.map